import { ColClassName, TranslateProps } from '../../../interfaces/Props';
import { chartStyle, getColorIfDefined, iconSize, isTranslateSame, wrapGauge } from './Shared';

import React from 'react';
import StatusGauge from '../StatusGauge';
import ThermometerIcon from 'mdi-react/ThermometerIcon';

const TemperatureInput = React.memo((props: TranslateProps & ColClassName & { temperatureInput?: number }) => {
  const foregroundColor = getColorIfDefined(props.temperatureInput, {
    hotLowerBound: 40,
    warmLowerBound: 10
  });

  return wrapGauge(
    <StatusGauge {...{
      chartStyle,
      title: props.translate(x => x.pages.status.temperatureInput),
      value: props.temperatureInput,
      minValue: -10,
      maxValue: 100,
      lineForeground: foregroundColor,
      unit: '°C',
      icon: <ThermometerIcon size={iconSize} color={foregroundColor} />
    }} />, props.colClassName);
}, (a, b) => a.temperatureInput === b.temperatureInput
  && isTranslateSame(a, b, x => x.pages.status.temperatureInput));

export default TemperatureInput;
